import { IItem } from 'types/entities';
import { EntityService } from '../entity.service';


class ItemsService extends EntityService<IItem> {
  readonly entityName = 'item';
}

export default new ItemsService();
